const ITEMS = [
  {
    number: '01',
    title: 'La méthode',
    description: 'Le système pas à pas, de zéro à ta première vente.',
  },
  {
    number: '02',
    title: 'Les outils',
    description: 'Des produits digitaux prêts à vendre et le Hustler Bot.',
  },
  {
    number: '03',
    title: 'L\'accompagnement',
    description: 'Du coaching en direct et des corrections sur ton business.',
  },
  {
    number: '04',
    title: 'La communauté',
    description: 'Un groupe privé de gens qui avancent en même temps que toi.',
  },
];

export const Deliverables = () => {
  return (
    <section data-testid="deliverables" className="px-5 md:px-8 py-6 md:py-12 bg-[#0D1F17]">
      <div className="max-w-3xl mx-auto flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <p className="microlabel">Ce que tu obtiens</p>
          <h2 className="text-[26px] sm:text-3xl md:text-5xl leading-[1.1] max-w-2xl">
            Une méthode, des outils, de l'accompagnement.{' '}
            <span className="font-serif-italic text-[#F5EFE3] font-normal italic">
              Tout ce qu'il te faut.
            </span>
          </h2>
        </div>

        <div className="flex flex-col">
          {ITEMS.map((item, idx) => (
            <div
              key={item.number}
              className="flex items-start gap-5 md:gap-7 py-6 md:py-7"
              style={{
                borderTop:
                  idx === 0 ? '1px solid rgba(245, 239, 227, 0.12)' : 'none',
                borderBottom: '1px solid rgba(245, 239, 227, 0.12)',
              }}
            >
              <span
                className="font-serif shrink-0"
                style={{
                  color: '#F5EFE3',
                  fontSize: 16,
                  lineHeight: 1.1,
                  paddingTop: 4,
                  minWidth: 32,
                }}
              >
                {item.number}
              </span>
              <div className="flex flex-col gap-2 flex-1">
                <h3
                  className="text-[#F5EFE3]"
                  style={{
                    fontSize: 20,
                    fontWeight: 700,
                    lineHeight: 1.2,
                    letterSpacing: '-0.01em',
                  }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-[#F5EFE3]/70"
                  style={{ fontSize: 15, lineHeight: 1.55 }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Deliverables;
